import { en } from "vuetify/lib/locale";

export default {
  ...en,

  core_values: {
    title: "Behaviors",
    title_s: "Behavior",
    title_short: "Behavior",
    title_short_s: "Behavior",
    behavior_title: "Examples",
    behavior_title_s: "Example"
  },
  mission: {
    title: "Purpose"
  }
};
